import React from 'react';
import classnames from 'classnames';

import { Button, Icon } from '..';

import { IconColor } from '../icon/icon';
import { FavouriteButtonStyle } from './favourite.style';
import { qaAttribute } from '../utils/qa-service';

const Favourite = ({ className, heartColour, isActive, onClick }: Props) => (
    <Button
        {...qaAttribute('favourite-button')}
        css={FavouriteButtonStyle}
        className={classnames('favourite', className ? { [className]: className } : '')}
        icon={
            <Icon
                data-testid={isActive ? 'full-heart' : 'empty-heart'}
                color={heartColour}
                type={isActive ? 'full-heart' : 'unfavorite'}
                className="favourite-icon"
            />
        }
        onClick={onClick}
        aria-label="favourite"
    />
);

Favourite.defaultProps = {
    className: '',
    heartColour: 'pink',
    isActive: false,
    onClick: () => {},
};

interface Props {
    className?: string;
    heartColour?: IconColor;
    isActive?: boolean;
    onClick?: (e: React.MouseEvent) => void;
}

export default Favourite;
